<ng-container>
  <div class="w-full py-3 flex align-items-center justify-content-between border-bottom-1 border-bottom-solid mb-3"
    [style]="{ 'border-color': 'var(--primary-gray)' }">
    <h2 class="text-xl font-semibold" data-clarity-unmask="true">Zmiana daty egzaminu</h2>
    <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" (onClick)="closeDialog()"
      [disabled]="loading" data-clarity-unmask="true"></p-button>
  </div>
</ng-container>
<p-calendar [inline]="true" [showTime]="true" hourFormat="24" [(ngModel)]="examDate" [maxDate]="maxDate"
  (ngModelChange)="showNothingChangedMessage = false"></p-calendar>
<p class="info-message mt-2" *ngIf="showNothingChangedMessage">Data oraz godzina egzaminu nie zostały zmienione. Wybierz
  nową datę z kalendarza lub anuluj zmiany.</p>
<div class="flex justify-content-center align-items-center gap-2 mt-3">
  <p-button (onClick)="closeDialog()" [outlined]="true" label="Anuluj" [disabled]="loading" data-clarity-unmask="true"></p-button>
  <p-button label="Zapisz" icon="pi pi-save" (onClick)="saveChanges()" [loading]="loading" data-clarity-unmask="true"></p-button>
</div>